export default new class Evil {
  evil(fn) {
    var Fn = Function; // 一个变量指向Function，防止前端编译工具报错
    return new Fn('return ' + fn)();
  }
}();



// WEBPACK FOOTER //
// ./src/common/util/evil.js